import { IMPORT_CREW, IMPORT_CREW_CLEAR_REDIRECT } from "./actions";

export const OnboardingStep1ClassName = 'crew-import-onboarding-step-1';
export const OnboardingStep2ClassName = 'crew-import-onboarding-step-2';

const defaultState = {
  importing: false,
  readOnly: false,
  onboardingSteps: [
    {
      target: '.' + OnboardingStep1ClassName,
      title: 'Films',
      content: `        
        Select which film you want to copy crew from.
      `
    },
    {
      target: '.' + OnboardingStep2ClassName,
      title: 'Copy',
      content: `Click the copy button to copy the crew.`
    }

  ]
};


const reducer = (state = defaultState, action: any = {}) => {
  switch (action.type) {

    case IMPORT_CREW + "_PENDING": {
      return {
        ...state,
        errors: null,
        importing: true
      };
    }

    case IMPORT_CREW + "_FULFILLED": {
      return {
        ...state,
        importing: false,
        errors: null,
        redirect: { to: "list" }
      };
    }

    case IMPORT_CREW + "_REJECTED": {
      return {
        ...state,
        errors: action.payload.response.data.errors,
        importing: false
      };
    }

    case IMPORT_CREW_CLEAR_REDIRECT: {
      return {
        ...state,
        department: null,
        redirect: null
      };
    }

    default:
      return state;
  }
};

export default reducer;
